<template>
	<div>
		<!-- 搜索区域 -->
		<div class="order-list-search" v-bind:class="[searchClass]">
			<div class="default" @click="toSearch">
				<img class="search" src="/static/img/search.png">
				<span>客户姓名/手机号</span>
			</div>
			<div class="clicked" id="clicked">
				<img class="search" src="/static/img/search.png">
				<input class="search-input" ref="search" type="text" v-model="searchValue" placeholder="客户姓名/手机号" @keyup="enter($event)">
				<img class="cancel-btn" src="/static/img/delete.png" @click="clearSearch">
			</div>
			<div class="cancel" @click="endSearch">取消</div>
			<div class="search-btn" @click="startSearch">搜索</div>
		</div>
		<!-- 订单列表 -->
		<div class="order-list" v-show="!searching">
			<div class="tabs">
				<div class="tab" :class="{active: selected == 1}" @click="onTabSelect(1)"><span>待支付</span></div>
				<div class="tab" :class="{active: selected == 2}" @click="onTabSelect(2)"><span>已支付</span></div>
				<div class="tab" :class="{active: selected == 3}" @click="onTabSelect(3)"><span>已完成</span></div>  
			</div>
			<!-- 待支付 -->
			<div class="content tab-content" v-show="selected == 1">
				<order-list url="/api/orders/manage/pending" emptyTitle="暂无待支付订单，单击右上角菜单新建订单" role="staff" @tabData="getPending"></order-list>
			</div> 
			<!-- 已支付 -->
			<div class="content tab-content" v-show="selected == 2">
				<order-list url="/api/orders/manage/payed" emptyTitle="暂无已支付订单" role="staff" @tabData="getPayed"></order-list>
			</div>
			<!-- 已完成 -->
			<div class="content tab-content" v-show="selected == 3">
				<order-list url="/api/orders/manage/finish" emptyTitle="暂无已完成订单" role="staff" @tabData="getFinish"></order-list>
			</div>
		</div>
		<div class="order-list" v-if="searching">
			<div class="content">
				<order-item v-for="item in showList" :key="item.order_id" :order="item" role="staff" :isSearching="item.showType"></order-item>
				<div class="empty" v-show="empty">
					<img src="/static/img/empty.png">
					<p>搜索结果为空</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import OrderList from '@/components/OrderList'
import OrderItem from '@/components/OrderItem'
import { mapGetters } from 'vuex'

export default {
	name: 'ManageOrderList',
	data: () => ({
		'selected': 1,
		'searching': false,
		'empty': false,
		'searchClass': '',
		'searchValue': '',
		'mixList': [],
		'showList': []
	}),
	computed: {
		...mapGetters({
			selectedTab: 'getTab',
			orderListSearch: 'getOrderListSearch'
		})
	},
	components: {
		OrderList,
		OrderItem
	},
	mounted: function () {
		this.setPageTitle('订单列表')
		this.selected = this.selectedTab.index
		this.searching = this.orderListSearch.searching
		this.searchValue = this.orderListSearch.searchValue
		this.searchClass = this.orderListSearch.searchClass
		this.showList = this.orderListSearch.showList
	},
	methods: {
		onTabSelect (tabIndex) {
			this.selected = tabIndex
			this.$store.dispatch('setTab', tabIndex)
		},
		// 获取数据到mixList数组
		getPending (data) {
			console.log('getPending.')
			data.forEach(d => {
				d.showType = '待支付'
				this.mixList.push(d)
			})
		},
		getPayed (data) {
			console.log('getPayed.')
			data.forEach(d => {
				d.showType = '已支付'
				this.mixList.push(d)
			})
		},
		getFinish (data) {
			console.log('getFinish.')
			data.forEach(d => {
				d.showType = '已完成'
				this.mixList.push(d)
			})
		},
		// 进入搜索区域
		toSearch () {
			this.searchClass = 'active'
			this.searchValue = ''
			let _this = this
			setTimeout(function () {
				_this.$refs.search.focus()
			}, 200)
		},
		// 开始搜索
		startSearch () {
			this.empty = false
			this.searchClass = 'result'
			let value = this.searchValue
			// 清空展示数组
			this.showList = []
			if (value === '') {
				this.endSearch()
			} else {
				// 转换value成数组values
				value = this.trimStr(value)
				let values = value.split(' ')
				// 对比values中检索条件，push需要展示的数据
				// console.log(this.mixList)
				this.mixList.forEach(d => {
					let customerStr = d.customer_name + d.customer_mobile
					if (values.length === 1) {
						if (customerStr.indexOf(values[0]) !== -1) {
							this.showList.push(d)
						}
					} else {
						if (customerStr.indexOf(values[0]) !== -1 && customerStr.indexOf(values[1]) !== -1) {
							this.showList.push(d)
						}
					}
				})
				if (this.showList.length === 0) {
					this.empty = true
				}
			}
			this.searching = true
			this.setListSearch()
		},
		// $store里面保存搜索状态
		setListSearch () {
			this.$store.dispatch('setOrderListSearch', {'orderListSearch': {
				searching: this.searching,
				searchValue: this.searchValue,
				searchClass: this.searchClass,
				showList: this.showList
			}})
		},
		// 结束搜索
		endSearch () {
			this.searchClass = ''
			this.searchValue = ''
			this.searching = false
			this.setListSearch()
		},
		// 清空搜索区域
		clearSearch () {
			if (this.searchClass === 'result') {
				this.endSearch()
			} else {
				this.searchClass = 'active'
				this.searchValue = ''
				this.$refs.search.focus()
			}
		},
		// 去掉字符串两侧空格
		trimStr (str) {
			str = str.replace(/(^\s*)|(\s*$)/g, '')
			str = str.replace(/\s+/g, ' ')
			return str
		},
		// 响应键盘点击事件
		enter: function (e) {
			if (e.keyCode === 13) {
				this.startSearch()
			}
		}
	},
	watch: {
		searchValue: {
			handler: function (val, oldval) {
				if (this.searchClass !== '' && val === '') {
					this.searchClass = 'active'
				} else {
					this.searchClass = 'begin'
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped>
/*搜索区域*/
.order-list-search{ position: fixed; top:50px; z-index: 101; width: 100%; height: 44px; background: #f5f5f5; padding: 9px 15px 8px; }
.order-list-search .default{ font-size: 13px; height: 27px;line-height: 25px; text-align: center; border: 1px solid #e2e2e2; border-radius: 6px; background: #fff; color: #999}
.order-list-search .search{ width: 14px; margin-right: 6px; vertical-align: -1px; }
.order-list-search .clicked{ display: none; width: calc(100% - 54px); float: left; height: 27px; line-height: 25px; border: 1px solid #e2e2e2; border-radius: 6px; padding:0 8px; background: #f5f5f9}
.order-list-search .clicked input{ width: calc(100% - 42px); border: none; background: transparent; outline: none; font-size: 13px; padding-left: 0; text-align: left; padding-top: 2px; padding-bottom: 2px;}
.order-list-search .cancel-btn{ display: none; float: right; width: 12px; margin: 6px 0 6px 3px;}
.order-list-search .cancel { display: none; font-size: 16px; color: #439aff; float: right; line-height: 27px; }
.order-list-search .search-btn { display: none; height: 27px; line-height: 27px; width: 42px; background: #439aff; color: #fff; float: right; text-align: center; border-radius: 4px; }

/*显示搜索区区块*/
.order-list-search.active{ background: #fff; }
.order-list-search.active .default{ display: none; }
.order-list-search.active .clicked{ display: block; width: calc(100% - 44px)}
.order-list-search.active .cancel{ display: block; }

/*开始输入搜索条件*/
.order-list-search.begin{ background: #fff; } 
.order-list-search.begin .default{ display: none; }
.order-list-search.begin .clicked,.order-list-search.begin .search-btn,.order-list-search.begin .cancel-btn{ display: block; }

/*显示输入结果*/
.order-list-search.result .default{ display: none; }
.order-list-search.result .clicked{ display: block; width: 100%; background: #fff;}
.order-list-search.result .search-btn{ display: none;}
.order-list-search.result .cancel{ display: none;}
.order-list-search.result .cancel-btn{ display: block;}

/*tab标题区域*/
.order-list .tabs{ top: 88px; }
/*内容区*/
.order-list .content.tab-content{ padding-top: 82px; }

</style>



// WEBPACK FOOTER //
// src/views/order/ManageOrderList.vue